// Lib
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { isMobile } from 'react-device-detect';

// Styles
import breakpoints from '../styles/breakpoints';

// Constants
import { LANDSCAPE_HEIGHT_DELTA } from '../constants/ui';

const useUI = () => {
  const theme = useTheme();
  const deltaViewportScreen = +localStorage.getItem('deltaViewportScreen') || 0;

  const isDesktopLandscape = useMediaQuery(
    `(min-height: ${
      breakpoints.values.lg - deltaViewportScreen
    }px) and (orientation: landscape)`,
  );
  const isTabletLandscape = useMediaQuery(
    `(max-height: ${
      breakpoints.values.lg - deltaViewportScreen - LANDSCAPE_HEIGHT_DELTA
    }px) and (orientation: landscape)`,
  );
  const isMobileLandscape = useMediaQuery(
    `(max-height: ${
      breakpoints.values.md - deltaViewportScreen - LANDSCAPE_HEIGHT_DELTA
    }px) and (orientation: landscape)`,
  );
  const isUpMdLandscape = useMediaQuery(
    `(min-height: ${
      breakpoints.values.md - deltaViewportScreen
    }px) and (orientation: landscape)`,
  );
  const isSmallMobileLandscape = useMediaQuery(
    `(max-height: ${
      breakpoints.values.sm - deltaViewportScreen - LANDSCAPE_HEIGHT_DELTA
    }px) and (orientation: landscape)`,
  );

  const isLandscapeOrientation = useMediaQuery(
    `screen and (orientation: landscape)`,
  );

  const isDesktopMode = useMediaQuery(theme.breakpoints.up('lg'));
  const isTabletMode = useMediaQuery(theme.breakpoints.down('lg'));
  const isMobileMode = useMediaQuery(theme.breakpoints.down('md'));
  const isSmallMobileMode = useMediaQuery(theme.breakpoints.down('sm'));
  const isUpMdMode = useMediaQuery(theme.breakpoints.up('md'));

  const isMobileLandscapeOrientation = isLandscapeOrientation && isMobile;

  return {
    isDesktopMode: isMobileLandscapeOrientation
      ? isDesktopLandscape
      : isDesktopMode,
    isTabletMode: isMobileLandscapeOrientation
      ? isTabletLandscape
      : isTabletMode,
    isMobileMode: isMobileLandscapeOrientation
      ? isMobileLandscape
      : isMobileMode,
    isSmallMobileMode: isMobileLandscapeOrientation
      ? isSmallMobileLandscape
      : isSmallMobileMode,
    isUpMdMode: isMobileLandscapeOrientation ? isUpMdLandscape : isUpMdMode,
    isMobileDevice: isMobile,
    isMobileLandscapeMode: isMobileLandscapeOrientation,
  };
};

export default useUI;
